<template>
  <div class="hello">
    <div v-if="loader">
      <Loader />
    </div>
    <div v-else class="banner">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <div class="banner-text">
              <h1 class="font-weight-bold mb-3">{{ headerText }}</h1>
              <p>
                <input type="checkbox" v-model="agree" /> {{ privacyText }} <a target="_blank" :href="termsUrl">
                  {{termsCondition}}</a> {{ privacyTextEnd }}
              </p>
              <div v-if="agree" class="align-items-center d-flex justify-content-center">
                <router-link class="button" to="/surveyView">{{ buttonText }}</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import getEnv from "@/config/env";
export default {
  name: "StartView",
  components: {
    Loader: () => import("@/components/Loader.vue"),
  },
  data() {
    return {
      loader: true,
      headerText: "このアンケートにご記入ください",
      buttonText: "始めましょう",
      privacyText: "",
      privacyPolicy: "プライバシーポリシー",
      termsCondition: "利用規約、プライバシーポリシー、秘密保持契約書",
      agree: true,
      termsUrl: "/terms-and-conditions",
      privacyTextEnd: "の内容を読み、同意します",
    };
  },
  created() {
    this.loader = false;
    this.setLanguage(this.$store.state.siteLanguage);
  },
  computed: {
    SiteLanguage() {
      return this.$store.state.siteLanguage;
    },
  },
  watch: {
    SiteLanguage(newSiteLanguage, oldSiteLanguage) {
      this.setLanguage(newSiteLanguage);
    },
  },
  methods: {
    setLanguage(siteLanguage) {
      if (siteLanguage === "ja") {
        this.headerText = "このアンケートにご記入ください";
        this.buttonText = "始めましょう";
        this.privacyText = "";
        this.privacyPolicy = "プライバシーポリシー";
        this.termsCondition = "利用規約、プライバシーポリシー、秘密保持契約書";
        this.privacyTextEnd = "の内容を読み、同意します";
      } else {
        this.headerText = "Please complete this survey";
        this.buttonText = "Get Started";
        this.privacyText = "I have read and agreed to the";
        this.termsCondition = "Terms & Conditions";
        this.privacyPolicy = "Privacy Policy";
        this.privacyTextEnd = "";
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.banner {
  height: 100vh;
}
.banner-text {
  padding-top: 0px;
  text-align: center;
}
</style>
